__turbopack_context__.v({
  "label": "_8zJxKa_label",
});
